import ReadMoreComment from './ReadMoreComment';

export default ReadMoreComment;
